export default {
	'validationModal.subTitleSuccess':
		'Customer’s new {{validationProperty}} was verified and successfully updated.',
	'validationModal.merchant.subTitleSuccess':
		'Merchant’s new email was verified and successfully updated.',
	'validationModal.subTitleWarning':
		'The verification {{validationProperty}} has expired, please use the link below to send a new one.',
	'validationModal.subTitleInfo':
		'A verification {{validationProperty}} was sent to {{updatedValue}}, please wait for confirmation... ',
	'validationModal.titleSuccess': '{{validationPropertyUp}} update completed',
	'validationModal.titleWarning': 'Verification {{validationProperty}} expired',
	'validationModal.titleInfo': 'Verification {{validationProperty}} sent',
	'validationModal.badgeInfo':
		'The verification {{validationProperty}} will expire after (10) minutes.',
	'validationModal.badgeWarning':
		'The verification {{validationProperty}} has expired!',
	'validationModal.badgeWarningResend':
		'Resend verification {{validationProperty}}',
	'validationModal.badgeSuccess': '{{validationPropertyUp}} update completed',
	'validationModal.toasterTitle':
		'New verification {{validationProperty}} sent',
	'validationModal.toasterMessage':
		'A new verification {{validationProperty}} was successfully sent.',
	'validationModal.successButton': 'Done',
};
